import CityPageTemplate from "../city-template/CityPageTemplate";
import { taylorConfig } from "./data";

export default function TaylorPage() {
  return <CityPageTemplate config={taylorConfig} />;
}